/**
 * Get the hero image for the commercial page
 * @param {object} heroImage - The hero image object
 * @returns {Array} - Array of hero images
 */
export const getCommercialPageHeroImage = ({
  heroImage,
}) => {
  const heroImages = [];
  const { heroImage: heroImageDesktop, heroImageMobile } = heroImage;
  const hasHeroImage = Object.keys(heroImage).length > 0 && heroImageDesktop;

  // if hasHeroImage is true, push the heroImageDesktop and heroImageMobile to the heroImages array
  // and also specify the size (image transformation name) of the image
  if (hasHeroImage) {
    heroImages.push({
      ...heroImageDesktop,
      size: 'hero-feature-desktop',
    });

    // in case mobile image is not provided, use the desktop image
    const mobileImage = heroImageMobile || heroImageDesktop;

    heroImages.push({
      ...mobileImage,
      size: 'hero-feature-mobile',
    });
  }

  return heroImages;
};
